import { cloneDeep } from 'lodash'
import { sort } from 'timsort'

import {
    ChannelState,
    DataNavigationState,
    GapsFlowMessage
} from 'plugin-live-exploratory-viz/src/data-navigation/types/widget'
import {
    getMultiChannelIdentifierWithLayerPrefix,
    sortCompare
} from 'plugin-live-exploratory-viz/src/data-navigation/reducer/utils'
import { getMultiChannelIdentifier } from 'plugin-live-exploratory-viz/src/services/channel/utils'
import { shouldDelayClearState } from 'plugin-live-exploratory-viz/src/data-navigation/reducer'

export function onGapsQuery(message: GapsFlowMessage, state: DataNavigationState): DataNavigationState {
    const series: Record<string, ChannelState> = {}
    // TODO: disable gap report for labels.
    for (const gap of message.events.gaps) {
        const isEventGap = gap.field !== 'value'
        if (isEventGap) {
            const isCalculatedEventGap = gap.field !== 'mnemonic'
            const qualifier = isCalculatedEventGap ? gap.field : gap.groups[0]
            const multiChannelIdentifier = getMultiChannelIdentifier(state.config.assetId, qualifier)
            const multiChannelIdentifierWithLayerPrefix = getMultiChannelIdentifierWithLayerPrefix(
                message.layer,
                multiChannelIdentifier
            )
            const serie =
                multiChannelIdentifierWithLayerPrefix in state.series
                    ? Object.assign({}, state.series[multiChannelIdentifierWithLayerPrefix])
                    : null

            if (serie) {
                // removing previous gaps
                serie.data.forEach((point, index) => {
                    if (point[1] === null) {
                        serie.data.splice(index, 1)
                    }
                })

                // Add new gaps
                for (const data of gap.gaps) {
                    // Should be validate if the begin and end timestamps
                    // is inside of a span?
                    const [begin, end] = data

                    // gap from minus infinity to the edge of the span should not be inserted in the series
                    // state.span[0] = min
                    if (begin == null && end != null && end <= state.span[0]) {
                        // return state
                        continue
                    }

                    // gap from the edge of the span to infinity should not be inserted in the series
                    // state.span[1] = max
                    if (begin != null && end == null && begin >= state.span[1]) {
                        // return state
                        continue
                    }

                    if (begin != null) {
                        serie.data.push([begin + Number.EPSILON, null])
                    }

                    if (end != null) {
                        serie.data.push([end + Number.EPSILON, null])
                    }
                }
                sort(serie.data, sortCompare)
                series[multiChannelIdentifierWithLayerPrefix] = serie
            }
        }
    }

    return {
        config: cloneDeep(state.config),
        realtime: state.realtime,
        series: { ...state.series, ...series },
        span: cloneDeep(state.span),
        shouldDelayClearState: shouldDelayClearState
    }
}
